<template>
  <div class="order-derails" v-if="orderInfo" :style="{zIndex: backdropZindex+1}">
    <img class="icon-close" src="./img/guanbi.svg" @click="handleClose">
    <template>
      <FloorBanner :orderInfo="orderInfo"></FloorBanner>
      <div class="order-desc">
        <dl>
          <dt>回收方式</dt>
          <dd>{{ orderInfo.orderType == '2' ? '信用回收' : orderInfo.recycleTypeName }}</dd>
        </dl>
        <dl>
          <dt>物流信息</dt>
          <dd v-if="orderInfo.routeList && orderInfo.routeList.length" class="route-list">
            <div
              v-for="(item,index) in orderInfo.routeList"
              :key="index"
              class="route-item"
            >
              <div class="route-item__remark">{{item.remark}}</div>
              <div class="route-item__time">{{item.time}}</div>
            </div>
          </dd>
          <dd v-else>暂无</dd>
        </dl>
        <dl>
          <dt>收款方式</dt>
          <dd>
            <p>{{ orderInfo.payInfo.payWayName }}</p>
            <p>{{ orderInfo.payInfo.payAccountName }}</p>
            <p>{{ orderInfo.payInfo.payAccount }}</p>
          </dd>
        </dl>
        <dl>
          <dt>订单明细</dt>
          <dd class="price-list">
            <div class="clearfix">
              <span class="fl">自主评估价格</span>
              <span class="fr price">￥{{ orderInfo.orderPrice / 100 }}</span>
            </div>
            <div v-if="orderInfo.orderType == '2'" class="clearfix">
              <span class="fl">预付款价格</span>
              <span class="fr price">￥{{ orderInfo.prepayPrice / 100 || 0 }}</span>
            </div>
            <template v-if="orderInfo.promotionInfo">
              <div class="clearfix" v-for="(item,index) in orderInfo.promotionInfo.activity" :key="index">
                <span class="fl">{{ item.activityName }}</span>
                <span class="fr price">¥{{ item.couponMoney/100 }}</span>
              </div>
              <div class="clearfix" v-for="(item,index) in orderInfo.promotionInfo.coupon" :key="index">
                <span class="fl">{{ item.couponName }}</span>
                <span class="fr price">¥{{ item.couponMoney/100 }}</span>
              </div>
            </template>
            <div class="clearfix">
              <span class="fl">订单总价</span>
              <span class="fr price">￥{{ orderInfo.totalPrice / 100 }}</span>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>其他信息</dt>
          <dd>
            <div>下单时间：{{ orderInfo.orderTime }}</div>
            <div>回收方式：{{ orderInfo.orderType == '2' ? '信用回收' : orderInfo.recycleTypeName }}</div>
            <div v-if="orderInfo.code">寄件码：{{ orderInfo.code }}</div>
            <div>收款方式：{{ orderInfo.payInfo.payWayName }}</div>
            <div>成交价：{{ orderInfo.payOutPrice / 100 || '订单未完成' }}</div>
          </dd>
        </dl>
      </div>
    </template>
  </div>
</template>

<script>
import Backdrop from '@/components/backdrop';
import { getOrderDetail } from '@/apis/base';
import { Message } from 'element-ui';
import FloorBanner from './floor-banner';

export default {
  components: {
    Backdrop,
    FloorBanner
  },
  props: {
    value: Boolean,
    orderNum: [String, Number]
  },
  data () {
    return {
      backdropZindex: 999,
      orderInfo: null
    };
  },
  watch: {
    orderNum (val) {
      this.getOrderDetail(val);
    }
  },
  methods: {
    async getOrderDetail (orderNum) {
      if (!orderNum) return;
      let ret = await getOrderDetail(orderNum);
      if (ret._errCode === '0') {
        this.orderInfo = ret._data;
      } else {
        Message.error(ret.errStr || '系统异常');
      }
      // console.log(this.orderInfo);
    },
    handleClose () {
      this.orderInfo = null;
      this.$emit('input', false);
      this.$emit('on-close', false);
    }
  },
  mounted () {
    this.getOrderDetail(this.orderNum);
  }
};
</script>

<style scoped>
.order-derails {
  position: fixed;
  width: 380px;
  left: 50%;
  top: 10%;
  margin-left: -190px;
  background-color: #fff;
}
.order-desc {
  overflow: hidden;
  padding-left: 30px;
  padding-right: 20px;
  padding-bottom: 20px;
}
dt {
  font-size: 16px;
}
dd {
  margin-left: 0;
  margin-top: 10px;
  font-size: 14px;
  line-height: 24px;
  color: #999;
}
.price-list {
  .fl {
    color: #333;
  }
  .price {
    color: #ff5f43;
  }
}
.icon-close {
  position: absolute;
  right: -28px;
  top: -16px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/orderDetails/index.vue